import { makeResetStyles, tokens } from '@fluentui/react-components';

export const useFolderGridCellDropStyle = makeResetStyles({
  outlineOffset: '6px',
  outlineStyle: 'dashed',
  outlineWidth: '2px',
  outlineColor: tokens.colorBrandBackground,
});
